module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/mlb/saves-02efa07880e2f4ce3f27265d24257f62.svg";